import { z } from 'zod';
import { addIssue } from './add-issue';

export const validateRequiredField = (
  value: any,
  path: Array<string | number>,
  message: string,
  ctx: {
    addIssue: (issue: z.IssueData) => void;
  },
) => {
  if (value === undefined || value === null || value === '') {
    addIssue(ctx, path, message);
    return false;
  }
  return true;
};
